import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
} from 'react-admin';
import { Box, Card, CardContent } from '@mui/material';

import countries from '../../constants/countries';
import cleaner from '../../utilities/dataProvider/cleaner';

const CarCreate = () => (
  <Create transform={cleaner}>
    <Card variant="outlined">
      <CardContent>
        <SimpleForm component={Box}>
          <TextInput validate={required()} source="registrationNumber" />
          <SelectInput
            source="registrationCountry"
            label="Registration country"
            choices={countries}
            validate={required()}
          />
          <TextInput source="vinCode" />
          <TextInput source="carModel" />
          <ReferenceArrayInput perPage={100} label="Groups" source="groups" reference="groups" filter={{ active: true }}>
            <SelectArrayInput optionText="name" label="groups" />
          </ReferenceArrayInput>
        </SimpleForm>
      </CardContent>
    </Card>
  </Create>
);

export default CarCreate;
